import { acceptInvitation } from './accept-invitation';
import { getInvitationStatus } from './get-invitation-status';
import { getUserInvitations } from './get-user-invitations';

export const InvitationsAPI = {
  getInvitationStatus,
  getUserInvitations,
  acceptInvitation,
};
